// extracted by mini-css-extract-plugin
export default {"terminals_container":"terminals_terminals_container__KaRsL","terminal":"terminals_terminal__bBRlO","icon":"terminals_icon__0Bh62"};